import { Constants } from '../constants';

export type Direction = Constants.RIGHT_TO_LEFT | Constants.LEFT_TO_RIGHT;

export const getTextDirection = (language = ''): Direction => {
  const rightToLeftLanguages: string[] = [`${Constants.ARABIAN_LANGUAGE}`];
  const isRTLLanguage = rightToLeftLanguages.includes(language);

  return isRTLLanguage ? Constants.RIGHT_TO_LEFT : Constants.LEFT_TO_RIGHT;
};
